import React, { useState } from "react";
import InputBox from "../../Component/UI/InputBox";
import AddButton from "../../Component/UI/AddButton";
import ReactSelect from "../../Component/UI/ReactSelect"
import { MdCheckCircle, MdOutlineCircle } from "react-icons/md";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { MdSearch, MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import CommonTableCheckbox from "../../../AdminPanel/Component/UI/CommonTableCheckbox";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { LuSend } from "react-icons/lu";
import { AiOutlinePlus } from "react-icons/ai";

export default function AddCampaignsModal({ productList, onClose, teamList, formData, handleChange, onSubmitForm,
  getMyUserListData, onSelectionChange, onSubmit, codeCountList, crrCodeObj, handleProductSelect }) {

  console.log("formData------///------>", formData)

  function getCodeCount(codeCountList = [], productId) {
    let count = codeCountList
      .filter(item => item.productId?.toString() === productId?.toString())
      .reduce((sum, item) => sum + (item.ordersCount || 0), 0);
    return count > 0 ? count : 0
  }

  const cards = productList && productList.length > 0 ? productList.map((ele) => ({
    id: ele.id,
    code: ele.code,
    title: ele.name,
    count: getCodeCount(codeCountList, ele.id)
  })) : [];


  const fields = [
    { label: "Campaign Name*", name: "title" },
  ];
  const fields2 = [
    { label: "Email Subject*", name: "subject" },
  ];


  const typeOptions = [
    { value: 'team', label: 'Team' },
    // { value: 'individual', label: 'Individual' }
  ];

  const teamOptions = teamList && teamList.length > 0 ? teamList.map((ele) => ({ value: ele.id, label: ele.name })) : [];


  console.log('teamOptionsteamOptionsteamOptionsteamOptions', teamOptions);

  // if (!isOpen) return null;
  const data = getMyUserListData && getMyUserListData.length > 0 ? getMyUserListData.map((ele, i) => ({
    sno: i + 1,
    id: ele.id,
    name: ele.name,
    email: ele.email
  })) : [];



  const columns = [
    { key: "sno", label: "S.No." },
    { key: "name", label: "Name" },
    { key: "email", label: "Email Address" },
    // { key: "role", label: "Role" },
  ];

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal Container section 1 */}

      {formData.stage === 1 &&
        <>
          <div className="relative bg-white w-full max-w-4xl rounded-2xl p-8 z-10">
            <div className="mb-6">
              <h2 className="text-xl font-semibold mb-1">Create Campaign</h2>
              <p className="text-sm textlight">Compose your email campaign in two simple steps</p>
            </div>

            <div className="flex items-center gap-4 mb-4">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bgcolor text-white flex items-center justify-center text-sm font-semibold">1</div>
                <span className="text-sm font-medium textcolor">Compose Email</span>
              </div>
              <div className="flex-1 h-[6px] bg-[#D9D9D9]" />
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#D9D9D9] textlight flex items-center justify-center text-sm font-semibold">2</div>
                <span className="text-sm font-medium textlight">Select Recipients</span>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                {fields.map(({ label, name }) => (
                  <InputBox
                    key={name}
                    label={label}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                  />
                ))}
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium">Recipients Type*</label>
                  <ReactSelect
                    name="type"
                    value={typeOptions.find(option => option.value === formData.type) || null}
                    options={typeOptions}
                    onChange={handleChange}
                    placeholder="Select Type"
                  />
                </div>
                {formData.type === "team" ?
                  <div>
                    <label className="text-sm font-medium">Choose Team*</label>
                    <ReactSelect
                      name="teamId"
                      value={teamOptions.find(option => option.value === formData.teamId) || null}
                      options={teamOptions}
                      onChange={handleChange}
                      placeholder="Select Team"
                    />

                  </div>
                  : null}

              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Select Assessment Type ({formData.productList.length})</label>
                <div className="grid grid-cols-2 gap-4">
                  {cards.map(({ id, title, count }) => {
                    const active = formData.productList.includes(id);
                    return (
                      <div
                        key={id}
                        onClick={() => handleProductSelect(id)}
                        className={`px-4 py-2 rounded-md flex items-center justify-between cursor-pointer border transition-all
                   ${active ? "border-[#1976D2] bg-[#E3F2FD]" : "border-gray-200 bg-gradient-to-r from-[#FFFFFF] to-[#E3F2FD]"}`}>

                        <div className="flex items-center gap-3">
                          <div className="flex items-center justify-center">
                            {active ? (
                              <MdCheckBox size={22} className="text-[#1976D2]" />
                            ) : (
                              <MdCheckBoxOutlineBlank size={22} className="text-[#D9D9D9]" />
                            )}
                          </div>
                          <div className={active ? "text-[#1976D2]" : ""}>
                            <p className="text-base py-1">{title}</p>
                            <p className={"text-sm textlight"}>{"Available Codes: " + count.toString()}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div>
                {fields2.map(({ label, name }) => (
                  <InputBox
                    key={name}
                    label={label}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                  />
                ))}
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email Message</label>
                <textarea
                  name={"message"}
                  value={formData["message"]}
                  onChange={handleChange}
                  placeholder="Write your message here..."
                  rows={2}
                  className="mt-0.5 w-full border rounded-md px-4 py-2 focus:ring-1 focus:ring-[#1976D2] outline-none disabled:bg-gray-100"
                />
              </div>
            </div>

            <div className="flex justify-end gap-4 mt-6">
              <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">Cancel</button>
              <AddButton onClick={() => onSubmitForm(cards[0])} title="Next: Select Recipients" className="bgcolor text-white px-6" />
            </div>

          </div >
        </>}


      {
        formData.stage === 2 &&
        <>
          <div className="relative bg-white w-full max-w-4xl rounded-2xl p-8 z-10">
            <div className="mb-6">
              <h2 className="text-xl font-semibold mb-1">Create Campaign</h2>
              <p className="text-sm textlight">Compose your email campaign in two simple steps</p>
            </div>
            <div className="flex items-center gap-4 mb-4">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bgcolor text-white flex items-center justify-center text-sm font-semibold">1</div>
                <span className="text-sm font-medium textcolor">Compose Email</span>
              </div>
              <div className="flex-1 h-[6px] bgcolor" />
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bgcolor text-white flex items-center justify-center text-sm font-semibold">2</div>
                <span className="text-sm font-medium textcolor">Select Recipients</span>
              </div>
            </div>

            <div className="bggray border border-gray-200 rounded-lg p-5 mb-4">
              <div className="space-y-2">
                <p className="text-base textblack">Users are showing as per selected assessment type{" "}
                  <span className="textblack font-medium">{crrCodeObj.title}</span>{" "} <span className="text-blue-600 font-medium underline">Change</span></p>

                {crrCodeObj.count < 9 ?
                  <div className="flex items-center space-x-3">
                    <p className="text-red-600 text-base">{"You are limited to select " + (crrCodeObj.count.toString()) + " users."}</p>
                    <AddButton onClick={() => onSubmit()} title="Get More Codes" className="bgcolor text-white px-4" />
                  </div>
                  :
                  <div></div>
                }

              </div>
            </div>


            <div className="border rounded-lg overflow-hidden">
              <div className="flex justify-between items-center px-4 pt-4 pb-2">
                <div className="flex items-center gap-2 text-sm text-black">
                  Show
                  <select className="border rounded-md px-2 py-1">
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  entries
                </div>

                <div className="flex items-center gap-3 text-sm text-black">
                  <div className="relative">
                    <MdSearch size={22} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input type="text" placeholder="Search" className="w-56 pl-9 pr-3 py-2 border border-[#D9D9D9] textlight rounded-md text-sm focus:outline-none" />
                  </div>

                  <div>1–20 of 150</div>
                  <div className="p-2 rounded-md bg-gray-200 text-teal-600">
                    <MdArrowBackIos size={20} />
                  </div>
                  <div className="p-2 rounded-md bg-gray-200 text-teal-600">
                    <MdArrowForwardIos size={20} />
                  </div>
                </div>
              </div>
              <div className="max-h-[260px] overflow-auto">
                <div className="overflow-x-auto bg-white p-4">
                  <CommonTableCheckbox
                    columns={columns}
                    data={data}
                    onSelectionChange={onSelectionChange}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-4 mt-6">
              <button onClick={() => onClose("prev")} className="px-6 py-2 border rounded-md">Previous</button>
              <AddButton onClick={() => onSubmit()} title="Send Campaign" Icon={LuSend} className="bgcolor text-white px-6" />
            </div>
          </div>
        </>
      }



    </div >
  );
}
